import THREE from "three";
import gaussian_vert from './shaders/gaussian_vert.glsl';
import gaussian_frag from './shaders/gaussian_frag.glsl';

import { ShaderPass } from './ShaderPass';

var GaussianShader = {
  uniforms: {
    tDiffuse: { type: "t", value: null },
    uColor: { type: "v4", value: new THREE.Vector4(1.0, 1.0, 1.0, 1.0) }
  },

  // defines: {
  //     KERNEL_SCALE_H:  1.0 / 64.0,
  //     KERNEL_SCALE_V:  1.0 / 64.0,
  //     KERNEL_RADIUS: 7.0
  // },

  vertexShader: gaussian_vert,
  fragmentShader: gaussian_frag
};

export class GaussianPass {
  _tmptarget = undefined;

  constructor(width, height, radius, scale, params) {
    this._width = width;
    this._height = height;
    this._radius = radius;
    this._scale = scale;
    this._params = params;

    this._blurRadius = this._radius || 3.0;
    this._pixelScale = this._scale || 1.0;

    this._params = {
      hasAlpha: params && params.hasAlpha || false,
      blending: params && params.blending || false,
      flipUV: params && params.flipUV || false
    };

    // INITIALIZATION

    // init shader passes
    this._blurPassH = new ShaderPass(GaussianShader);
    this._blurPassV = new ShaderPass(GaussianShader);

    // init target
    this.setSize(this._width, this._height);

    this._blurPassH.material.blending = this._blurPassV.material.blending = THREE.NoBlending;
    this._blurPassH.material.depthWrite = this._blurPassV.material.depthWrite = false;
    this._blurPassH.material.depthTest = this._blurPassV.material.depthTest = false;
    this._blurPassH.material.defines.HORIZONTAL = 1;

    this._blurPassH.material.defines.KERNEL_RADIUS = this._blurPassV.material.defines.KERNEL_RADIUS = this._blurRadius.toFixed(1);

    if (this._params.blending) {
      this._blurPassV.material.transparent = true;
      this._blurPassV.material.blending = THREE.NormalBlending;
    }

    if (this._params.hasAlpha)
    this._blurPassH.material.defines.HAS_ALPHA = this._blurPassV.material.defines.HAS_ALPHA = "";

    if (this._params.flipUV)
    this._blurPassH.material.defines.FLIP_UV = "";
  }

  // PUBLIC FUNCTIONS
  render(renderer, writeBuffer, readBuffer) {
    this._blurPassH.render(renderer, this._tmptarget, readBuffer); // from readBuffer to intermediary tmp
    this._blurPassV.render(renderer, writeBuffer, this._tmptarget); // tmp out to write
  }

  setSize(width, height) {
    this.cleanup();

    this._width = width;
    this._height = height;

    this._tmptarget = new THREE.WebGLRenderTarget(this._width, this._height, {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      format: this._params.format !== undefined ? this._params.format : THREE.RGBAFormat, // use RGBA by default
      type: this._params.type !== undefined ? this._params.type : THREE.UnsignedByteType, // use Uint8 by default
      stencilBuffer: false
    });
    this._tmptarget.texture.generateMipmaps = false;

    this._blurPassH.material.defines.KERNEL_SCALE_H = this._blurPassV.material.defines.KERNEL_SCALE_H = (this._pixelScale / this._width).toFixed(4);
    this._blurPassH.material.defines.KERNEL_SCALE_V = this._blurPassV.material.defines.KERNEL_SCALE_V = (this._pixelScale / this._height).toFixed(4);
    this._blurPassH.material.needsUpdate = this._blurPassV.material.needsUpdate = true;
  }

  cleanup() {
    if (this._tmptarget) {
      this._tmptarget.dispose();
    }
  }

  setColor(color) {
    this._blurPassV.material.uniforms.uColor.value.set(color.r, color.g, color.b);
  }

  setAlpha(alpha) {
    this._blurPassV.material.uniforms.uColor.value.w = alpha;
  }

}